var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"topic-title"},[_vm._v("2024 Key Topics")])
}
var staticRenderFns = []

export { render, staticRenderFns }